import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';

@Injectable()
export class IsSalesReadonlyFeature implements IFlagFeature {
  name = Features.IsSalesReadonly;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
